<ng-container *ngIf="cs.vm$ | async as vm">
  <div [content]="errorPageContentBlock" editable-area></div>

  <div [content]="main" editable-area></div>
</ng-container>
